var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBeauty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2211",
    transform: "translate(-318 -336)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 40",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(318 336)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 21.1v-2.7H28v2.7zm1.8 5.4v-2.7h7.2v2.7zM17.47 40l-2.115-7.695a11.22 11.22 0 0 1-3.915-4.275A12.61 12.61 0 0 1 10 22a12.742 12.742 0 0 1 1.44-6.053 10.84 10.84 0 0 1 3.915-4.247L17.47 4h10.26l2.115 7.7a10.84 10.84 0 0 1 3.915 4.253A12.742 12.742 0 0 1 35.2 22a12.61 12.61 0 0 1-1.44 6.03 11.22 11.22 0 0 1-3.915 4.275L27.73 40zm5.13-8.1a9.834 9.834 0 0 0 9.9-9.9 9.834 9.834 0 0 0-9.9-9.9 9.834 9.834 0 0 0-9.9 9.9 9.834 9.834 0 0 0 9.9 9.9zm-3.915-21.78a15.369 15.369 0 0 1 2-.473 11.691 11.691 0 0 1 3.825 0 15.369 15.369 0 0 1 2 .473L25.7 6.7h-6.2zm.81 27.18H25.7l.81-3.42q-1.035.27-2 .427a11.691 11.691 0 0 1-3.825 0q-.967-.157-2-.427zm-.81-30.6zm.81 30.6z",
    transform: "translate(326 345)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeauty);
export default __webpack_public_path__ + "static/media/icon-beauty.251823a2.svg";
export { ForwardRef as ReactComponent };